module.exports = __webpack_public_path__ + "static/media/search_icon3.de6cade6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search_icon3.svg
// module id = 170
// module chunks = 0